import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlSegment } from '@angular/router';
import { AuthStore } from '../auth/store/auth.store';

export const restrictedAreaMatchGuard: CanMatchFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.loggedIn()) {
    return true;
  } else {
    return router.createUrlTree(['/', 'auth', 'login']);
  }
};
